import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Checkbox, Input } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import cx from 'classnames';
import formStyles from 'styles/form';
import RTCheckbox from 'styles/checkbox.scss';
import { error } from '../../../../utils';

const titleStyle = cx(formStyles.bottomTitle, formStyles.childTitle);
const DEFAULT_STATE = {
  rushRequest: false,
  commercialRefigure: false,
  rushRequestNote: '',
};

class SpecialOptions extends Component {

  state = DEFAULT_STATE

  handleSpecialOptions = (key, value) => {
    const state = this.state;
    state[key] = value;
    this.setState({ ...state });
    this.props.updateSpecialOptions(this.state);
  }

  handleRushChange = (value) => {
    this.handleSpecialOptions('rushRequest', value);
  }

  handleCommercialChange = (value) => {
    this.handleSpecialOptions('commercialRefigure', value);
  }

  handleRushNoteChange = (value) => {
    this.handleSpecialOptions('rushRequestNote', value);
  }

  render() {
    const { rushRequest, commercialRefigure, rushRequestNote } = this.state;
    return (
      <div className={formStyles.divider}>
        <h5 className={titleStyle}>Special Options (may not be applicable)</h5>
        <FlexBox flexWrap="wrap">
          <Checkbox
            checked={rushRequest}
            label="RUSH REQUEST (CUSTOMER IN STORE)"
            theme={RTCheckbox}
            className={formStyles.checkboxListItem}
            onChange={this.handleRushChange}
          />
          <Checkbox
            checked={commercialRefigure}
            label="COMMERCIAL REFIGURE (REQUIRES APPROVAL)"
            theme={RTCheckbox}
            className={formStyles.checkboxListItem}
            onChange={this.handleCommercialChange}
          />
        </FlexBox>
        {rushRequest && <Input
          multiline
          required
          label="Reason For Rush Request"
          theme={formStyles}
          value={rushRequestNote}
          className={formStyles.textArea}
          error={error('rushRequestNote', this.props.errors)}
          onChange={this.handleRushNoteChange}
        />}
      </div>
    );
  }
}

SpecialOptions.propTypes = {
  updateSpecialOptions: PropTypes.func,
  errors: PropTypes.object,
};

export default SpecialOptions;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/components/specialOptions.jsx